<template>
  <div class="classroom">
    <!-- 标题栏 -->
    <!-- <van-nav-bar left-arrow title="密训课堂" @click-left="onClickLeft" />  -->
    <div>
    <div class="page">
      <div class="header">
        <!-- <img src="img/index/img_bg.png" /> -->
        <div class="kqb-tools disp-flex">
          <!--搜索框-->
          <div class="kqb-search-bar">
            <img src="img/index/icon_search.png" class="icon_search" />
            <input
              placeholder-class="placeholder"
              type="text"
              placeholder="输入关键字搜索课程"
            />
          </div>
        </div>
      </div>

      <!-- 轮播图 -->
      <div class="wrapper">
        <swiper
          style="width: 90%; height: 100%"
          :options="swiperOption"
          ref="mySwiper"
        >
          <swiper-slide v-for="item of swiperList" :key="item.id">
            <img class="swiper-img" :src="item.imgUrl" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 导航栏 -->
      <!-- <div class="nav-bar" >
        <div
          class="nav-bar-item"
          @click="pageJumpCate('/categories?from=yixue')"
        >
          <img src="img/index/categories.png" />
          <div>全部分类</div>
        </div>
        <div
          class="nav-bar-item"
        >
          <img src="img/index/guzheng.png"
          @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=guzheng')"/>
          <div>古筝</div>
        </div>
        <div class="nav-bar-item"
         @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=feizhougu')">
          <img src="img/index/feizhougu.png" />
          <div>非洲鼓</div>
        </div>
        <div class="nav-bar-item"
          @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=jueshigu')">
          <img src="img/index/jueshigu.png" />
          <div>爵士鼓</div>
        </div>
        <div class="nav-bar-item"
        @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=talk')">
          <img src="img/index/koucai.png" />
          <div>口才</div>
        </div>
                <div class="nav-bar-item"
        @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=talk')">
          <img src="img/index/koucai.png" />
          <div>口才</div>
        </div>
                <div class="nav-bar-item"
        @click="pageJumpCategories('/subCategories?goodsCategoryNameEn=talk')">
          <img src="img/index/koucai.png" />
          <div>口才</div>
        </div>

      </div> -->


      <!-- 滑动导航栏 -->
      <div v-if="flag">
      <div class="navBox">
       <ul class="ul">
         <li class="li" :class="{'li-activate': navIndex == index}" v-for="(item, index) in Categories" :key="index" @click="handleNavClick(index)">
           <!-- 图片 -->
           <div
            @click="[item.goodsCategoryNameEn == 'all'? pageJumpCate('/categories?from=yixue&storeId='+{storeId})
                              :  pageJumpCategories('/subcategories', item)] "
           >
            <img :src='item.goodsCategoryIconImg' alt="" class="nav_img">
            <span style="top:10px;font-size:13px">{{item.goodsCategoryName}}</span>
           </div>
         </li>
       </ul>
      </div>
      </div>
      <div v-else>
        <div class="nav-bar">
        <div class="nav-bar-item" >
          <img src="img/index/categories.png" class="nav_img"/>
          <div style="top:5px;font-size:13px">全部</div>
        </div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="tableTitle"></div>
      </div>

      <div class="section" style="height:720px;">
        <div v-if="flag">
        <div class="section-title disp-flex-between" style="margin-bottom: 3px">
          <div>最新课程</div>
          <div class="more disp-flex" @click="pageJumpMore('/more')">
            <div style="font-size:13px;">更多</div>
            <div class="icon" ></div>
          </div>
        </div>
        <div class="kqb-media-list hotclass">
          <div
            class="kqb-media-item"
            v-for="(item, index) in hotSubjectList"
            :key="index"
            @click="pageJump('/mediaRecommendationDetail', item)"
          >
            <div class="kqb-media-object">
            <img v-lazy="item.goodsImgs" class="kqb-media-object-img" />
            </div>
            <div class="kqb-media-inner">
              <div class="kqb-media-title ellipsis">
                {{ item.goodsLongName }}
              </div>
              <div class="kqb-media-desc ellipsis"></div>
              <!-- <div class="kqb-media-label">主讲人：{{item.goodsLecturerName}}</div> -->
              <div class="kqb-media-label">{{ item.countStudy?item.countStudy:0 }}人学习</div>
              <div
                class="kqb-media-footer fc-FF1A1A"
                v-if="item.goodsIsVip == 1"
              >
                {{ item.goodsQuantity }}课/VIP
              </div>
              <div class="kqb-media-footer fc-F82E3D" v-else>
                <div class="fc-FF1A1A">{{ item.goodsQuantity }}课</div>
                <div class="fc-FF1A1A fc-000">￥{{item.goodsNewPrice/100}}</div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <div v-else >
          <div class="section-title disp-flex-between" style="margin-bottom: 3px">
          <div>最新课程</div>
          <div class="more disp-flex" >
            <div style="font-size:13px;">更多</div>
            <div class="icon"></div>
          </div>
        </div>
        <div>
          <h2 style="margin-top:150px;">暂 无 课 程</h2>
        </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div style="height: 70px; width: auto; background-color: #eae8e8;"></div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
export default {
  name: "classroom",
  data() {
    return {
      active: 0, // 当前展示哪个tab
      //轮播图
      swiperOption: {
        pagination: ".swiper-pagination",
        //修改分页器样式 ,
        bulletClass: "my-swiper-pagination-bullet",
        //激活样式
        bulletActiveClass: "my-bullet-active",
        //属性设置 自动轮播
        autoplay: true,
        speed: 3000,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        loop: true,
      },
      swiperList: [
        {
          id: "0001",
          imgUrl:
            "img/index/nav.jpg",
        },
        {
          id: "0002",
           imgUrl:
            "img/index/nav.jpg",
        },
        {
          id: "0003",
           imgUrl:
            "img/index/nav.jpg",
        },
      ],
      //导航栏
      navList: [
        {
         name:'全部分类',
         img:'img/index/categories.png',
         goodsCategoryNameEn:'all'
       },
        {
         name:'非洲鼓',
         img:'img/index/categories.png',
         goodsCategoryNameEn:'feizhougu'
       },
        {
         name:'爵士鼓',
         img:'img/index/categories.png',
         goodsCategoryNameEn:'jueshigu'
       },
        {
         name:'口才',
         img:'img/index/categories.png',
         goodsCategoryNameEn:'talk'
       },
        {
         name:'口才',
         img:'img/index/categories.png'
       },
        {
         name:'爵士鼓',
         img:'img/index/categories.png'
       }
      ],
      navIndex: 0,
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      audioRecommendations: {}, // 音频推荐数据
      hotSubjectList: [], // 热门课程数据
      flag:'',          //判断是否有课程
      Categories:[],      //所有分类
      // guessFavoriteList: [], // 猜你喜欢
      isVip: 0,
      storeId: "",
      userId: "",
      isMiniProgram: true,
    };
  },
  created() {
    const thisObj = this;
    thisObj.onLoad();
    // 调用热门课程数据获取方法
    // thisObj.getHotSubjectInfo()
    // 调用猜你喜欢数据获取方法
    // thisObj.getFavoriteVedios()
    this.checkIsFromMiniProgram(function (res) {
      thisObj.isMiniProgram = res;
    });
  },
  methods: {
    onLoad: function () {
      console.log("classroom");
      // //获取所有分类
      // thisObj.getAllCategories();
      // this.getAllCategories();
      var personInfo = {};
      var personId = this.$util.getUrlParam("personId");
      var personNickName = this.$util.getUrlParam("personNickName");
      var personToken = this.$util.getUrlParam("personToken");
      var personMobileNo = this.$util.getUrlParam("personMobileNo");
      var personHeadImg = this.$util.getUrlParam("personHeadImg");
      var personLoginTimeStamp = this.$util.getUrlParam("personLoginTimeStamp");
      var personIsVip = this.$util.getUrlParam("personIsVip");
      var personOpenId = this.$util.getUrlParam("personOpenId");
      var storeId = this.$util.getUrlParam("storeId");
      let value = this.$util.getUrlParam("code");
      this.storeId = storeId;
      //保存storeId
      sessionStorage.setItem("storeId",storeId)
      this.userId = personId;

      if (personId != null) {
        personInfo["personAccountInfoId"] = personId;
        personInfo["personAccountToken"] = personToken;
        personInfo["personLoginTimeStamp"] = personLoginTimeStamp;
        personInfo["personAccountInfoDsfOpenId"] = personOpenId;
        personInfo["personAccountInfoHeadImg"] = personHeadImg;
        personInfo["personAccountInfoNickName"] = personNickName;
        personInfo["personMobileNo"] = personMobileNo;
        personInfo["personIsVip"] = personIsVip;
        personInfo["storeId"] = storeId;
        this.isVip = parseInt(personIsVip);
        this.$root.userInfo = personInfo;
        this.$root.isLogin = true;
        const thisObj = this;
        //获取所有分类
        thisObj.getAllCategories();
        // 调用热门课程数据获取方法
        thisObj.getSubjectByCategoriesName();
      } 
      // else if (this.$util.getUrlParam("isUser") === "1") {
      //   const thisObj = this;
      //   let countS = this.$util.getUrlParam("cS");
      //   thisObj.goodsId = this.$util.getUrlParam("gId");
      //   thisObj.countStudy = countS;
      //   //   thisObj.isNew = true
      //   let upId = this.$util.getUrlParam("upId");
      //   let apNam = this.$util.getUrlParam("aN");
      //   let isUserInfo =
      //     apNam + "!" + upId + "!" + thisObj.goodsId + "!" + countS;
      //   let paIsInfo = escape(isUserInfo);
      //   window.location.href =
      //     "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=" +
      //     paIsInfo +
      //     "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      // } else if (value !== null) {
       else if (this.$util.getUrlParam("isUser") === "1") {
        var that = this;
        const thisObj = this;
        let paInfo = this.$util.getUrlParam("isUser");
        paInfo = unescape(paInfo);
        let infos = paInfo.split("!");
        let countS = this.$util.getUrlParam("cS");
        thisObj.goodsId = this.$util.getUrlParam("gId");
        let upId = this.$util.getUrlParam("upId");
        let apNam = this.$util.getUrlParam("aN");
        thisObj.storeId = apNam;
        let upUserId = upId;
        let goodsId = thisObj.goodsId;
        let countStudy = countS;
        let usInfos;
        // if (value != null) {
        //   that.$api
        //     .post(that.requestUrl + "/weixin/get/person/info?fromDevice=h5", {
        //       weixinCode: value,
        //     })
        //     .then((res) => {
        //       const userInfo = res.resultData;
        //       this.$root.userInfo = userInfo;
        //       usInfos = userInfo;
        //       this.$root.isLogin = true;
        //       var wx = require("weixin-js-sdk");
        //       var href = window.location.href;
        //       var urlConfig =
        //         that.requestUrl + "/weixin/get/js/config?fromDevice=h5";
        //       that.$api.post(urlConfig, { url: href }).then((res) => {
        //         if (res.resultCode === 200 && res.success) {
        //           wx.config({
        //             debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //             appId: res.resultData.appid, // 必填，公众号的唯一标识
        //             timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
        //             nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
        //             signature: res.resultData.sign, // 必填，签名
        //             jsApiList: ["checkJsApi", "chooseWXPay"], // 必填，需要使用的JS接口列表/person/login
        //           });
        //         }
        //       });
        //       that.$api
        //         .post(that.requestUrl + "/person/login/weixin", {
        //           storeId: thisObj.storeId,
        //           wxOpenId: usInfos.personAccountInfoDsfOpenId,
        //           wxHeadImg: usInfos.personAccountInfoDsfHeadImg,
        //           wxCity: usInfos.personAccountInfoDsfCity,
        //           wxCountry: usInfos.personAccountInfoDsfCountry,
        //           wxNickName: usInfos.personAccountInfoDsfNickName,
        //           wxProvince: usInfos.personAccountInfoDsfProvince,
        //           wxPrivilege: "",
        //           wxSex: usInfos.personAccountInfoSex,
        //           wxUnionid: usInfos.personAccountInfoDsfUnionid,
        //           mobileNo: "",
        //           mobileCode: "",
        //           personParentId: upUserId,
        //           fromAppName: "客渠邦服务号",
        //         })
        //         .then((res) => {
        //           const userInfo = res.resultData;
        //           this.$root.userInfo = userInfo;
        //           this.$root.isLogin = true;
        //         });
        //     });
        // } else {
        //   //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zklm.kequbang.com?isUser=' + thisObj.storeId + '!' + upUserId + '!' + that.goodsId + '!' + that.countStudy + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        // }
        this.pageNewJump(thisObj.storeId, upUserId, goodsId, countStudy);
      }
    },
    //导航栏滑动
    handleNavClick (index) {
      this.navIndex = index;
    },
    // 获取热门课程数据方法
    getHotSubjectInfo() {
      const thisObj = this;
      thisObj.$api
        .get(
          thisObj.requestUrl +
            "/knowledge/goods/info/getKnowledgeHotSubject?fromDevice=h5&storeId=" +
            this.storeId,
          {}
        )
        .then((res) => {
          // console.log(res)
          if (res.resultCode === 200 && res.success) {
            if (res.resultData.length <= 5) {
              thisObj.hotSubjectList = res.resultData;
            } else {
              let hotLset = [];
              for (let i = 0; i <= 5; i++) {
                hotLset.push(res.resultData[i]);
              }
              thisObj.hotSubjectList = hotLset;
              console.log("hotSubject ")
              console.log(thisObj.hotSubjectList)
            }
            thisObj.audioRecommendations = thisObj.hotSubjectList[0];
          } else {
            // thisObj.$util.requetServerError(res.resultMsg);
          }
          console.log(hotSubjectList);
        })
        .catch(function (error) {
          // thisObj.$util.requetServerError(error);
        });
    },
   //获取指定分类下的课程
    getSubjectByCategoriesName(){
      const that = this;
      var name = "all";
      that.$api
      .get(
        that.requestUrl+
        "/knowledge/goods/selectSubjectByGoodsCategoryNameEn?fromDevice=h5&storeId=" +
          this.storeId+"&name="+name,
        {}
      )
      .then((res) => {
        if(res.success){
          if(res.resultData.length == 0){
            console.log("没有课程")
            // that.flag = false;
            // console.log(that.flag);

          }else{
            // that.flag = true;
            // console.log(that.flag);
            if(res.resultData.length <=5 ){
                that.hotSubjectList = res.resultData
            }else{
                let temp = [];
                for(let i=0;i<=5;i++){
                temp.push(res.resultData[i]);
                }
                console.log(temp)
                that.hotSubjectList = temp;
            }
          }


        }else{
          console.error("未能成功获取数据")
        }
      })
    },
    //获取一级分类
    getAllCategories(){
      const that = this;
      console.log("getAllCategories ")
      that.$api
        .get(
          that.requestUrl+
          "/knowledge/goods/getAllCategories?fromDevice=h5&storeId=" +
            this.storeId,
          {}
        )
        .then((res) => {
          if(res.success){
            //判断有无分类
            if(res.resultData.length == 0){
              console.log("没有分类")
              that.flag = false;
              console.log(that.flag);
            }else{
              that.Categories = res.resultData;
              that.flag = true;
              console.log("Categories")
              console.log(that.Categories);
              //查到有分类 直接获取最新课程
              that.getSubjectByCategoriesName();
            }
          }else{
            console.log("未成功获取数据")
          }
        })
    },
    // 二维码进入页面跳转
    pageNewJump(storeId, upUserId, goodsId, countStudy) {
      const thisObj = this;
      let eUrl = "/mediaRecommendationDetail";
      let queryData = {
        storeId: storeId,
        upUserId: upUserId,
        isUser: "2",
        goodsId: goodsId,
        countStudy: countStudy,
      };
      thisObj.$router.push({
        path: eUrl,
        query: queryData,
      });
    },
    // 页面跳转
    pageJump(uri, item) {
      const thisObj = this;
      let queryData = {
        fileType: item.goodsType,
        goodsId: item.goodsId,
        goodsName: item.goodsLongName,
        goodsLecturerName: item.goodsLecturerName,
        goodsBriefDesc: item.goodsBriefDesc,
        goodsLecturerDesc: item.goodsLecturerDesc,
        goodsQuantity: item.goodsQuantity,
        countStudy: item.countStudy,
        goodsNo: item.goodsNo,
        goodsDetailImgs: item.goodsNativeDetailDesc,
        goodsFirstImg: item.goodsFirstImg,
        goodsIsVip: item.goodsIsVip,
        isUser: "0",
        storeId: this.storeId,
        userId: this.userId,
      };
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    //页面跳转到更多页面
    pageJumpMore(uri) {
      const thisObj = this;
      thisObj.$router.push({
        path: uri,
      });
    },
    // 页面跳转
    pageJumpCate(uri) {
      const thisObj = this;
      let queryData = {};
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    // 分类跳转
    pageJumpCategories(uri, item){
      // const that = this;
      // let temp = "";
      // console.log(this.Categories);
      // if(uri.indexOf("guzheng")){
      //   console.log("guzheng")
      //   temp = '古筝';
      // }
      const thisObj = this;
      let queryData = {
        goodsCategoryName: item.goodsCategoryName,
        goodsCategoryId: item.goodsCategoryId,
      };
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    // 支付会员费用
    commitPay() {
      var that = this;
      var person = this.$root.userInfo;
      var isLogin = (that.$root.isLogin = true);
      if (!isLogin) {
        that.$util.requetServerError("亲,你还没有登录,请先登录");
      } else {
        var wx = require("weixin-js-sdk");
        var href = window.location.href;
        var urlConfig = that.requestUrl + "/weixin/get/js/config?fromDevice=h5";
        // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
        that.$api
          .post(urlConfig, { url: href, storeId: person.storeId })
          .then((res) => {
            console.log(res);
            if (res.resultCode === 200 && res.success) {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.resultData.appid, // 必填，公众号的唯一标识
                timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.resultData.noncestr, // 必填，生成签名的随机串
                signature: res.resultData.sign, // 必填，签名
                jsApiList: ["checkJsApi", "chooseWXPay"], // 必填，需要使用的JS接口列表
              });
              var url =
                that.requestUrl +
                "/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=" +
                person.personAccountInfoId +
                "&storeId=" +
                person.storeId +
                "&personToken=" +
                person.personAccountToken +
                "&loginTimestamp=" +
                person.personLoginTimeStamp +
                "&personOpenId=" +
                person.personAccountInfoDsfOpenId;
              // var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + '' + '&storeId=' + 'STOREINFOFBCB01621A0AFE62F036E8C9D0B01ABC' + '&personToken=' + '' + '&loginTimestamp=' + '' + '&personOpenId=' + ''
              that.$api
                .get(url, {})
                .then((result) => {
                  console.log(result);
                  if (result.resultCode === 200 && result.success) {
                    wx.chooseWXPay({
                      timestamp: result.resultData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                      nonceStr: result.resultData.nonceStr, // 支付签名随机串，不长于 32 位
                      package: result.resultData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                      signType: result.resultData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                      paySign: result.resultData.sign, // 支付签名
                      success: function (res) {
                        // 支付成功后的回调函数
                        person.isVip = 1;
                        this.isVip = 1;
                        this.$root.userInfo = person;
                        that.$util.showSuccessMsg("开通会员成功");
                      },
                      cancel: function () {
                        alert("支付已取消");
                      },
                      error: function (e) {},
                    });
                  } else {
                    that.$util.requetServerError(res.resultMsg);
                  }
                })
                .catch(function (error) {
                  that.$util.requetServerError(error);
                });
            } else {
              that.$util.requetServerError(res.resultMsg);
            }
          });
      }
    },
    // 跳转小程序支付
    // 判断来源是否是小程序
    checkIsFromMiniProgram: function (callback) {
      wx.miniProgram.getEnv(function (res) {
        console.log("minprogram:" + res.miniprogram); // true
        //  alert(JSON.stringify(res));
        if (res.miniprogram === true) {
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(true);
          // alert('isMiniprogram:' + res.miniprogram);
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(false);
          // alert("========公众号");
        }
      });
    },
    // 跳转到小程序
    navigateToMiniProgram: function (payParam) {
      const url = "/pages/wxPay/wxPay?payParam=" + encodeURIComponent(payParam);
      //   alert('url:' + url)
      wx.miniProgram.navigateTo({
        url: url,
      });
    },
    // 小程序和公众号跳转不同页面
    navigateToPay: function () {
      //   if (this.isMiniProgram === true) {
      // alert('小程序')
      // 由后台协商好返回的数据格式，该代码仅供参考，不能实际使用
      var that = this;
      var person = this.$root.userInfo;
      //   var isLogin = that.$root.isLogin = true
      var url =
        that.requestUrl +
        "/auth/knowledge/vip/knowledge/confirm/pay?fromDevice=h5&personId=" +
        person.personAccountInfoId +
        "&storeId=" +
        person.storeId +
        "&personToken=" +
        person.personAccountToken +
        "&loginTimestamp=" +
        person.personLoginTimeStamp +
        "&personOpenId=" +
        person.personAccountInfoDsfOpenId;
      // var url = that.requestUrl + '/auth/knowledge/vip/official/confirm/pay?fromDevice=h5&personId=' + '' + '&storeId=' + 'STOREINFOFBCB01621A0AFE62F036E8C9D0B01ABC' + '&personToken=' + '' + '&loginTimestamp=' + '' + '&personOpenId=' + ''
      that.$api
        .get(url, {})
        .then((result) => {
          console.log(result);
          if (result.resultCode === 200 && result.success) {
            const payParam = {
              appId: result.resultData.appId,
              package: result.resultData.package,
              paySign: result.resultData.sign,
              signType: "MD5",
              timeStamp: result.resultData.timeStamp,
              nonceStr: result.resultData.nonceStr,
            };
            this.navigateToMiniProgram(JSON.stringify(payParam));
          } else {
            that.$util.showSuccessMsg(result.resultMsg);
          }
        })
        .catch(function (error) {
          // that.$util.requetServerError(error);
        });
    },
  },
};
</script>
<style lang='less' scoped>
.navBox {
  width: 100%;
  top: -30px;
  height:130px;
  .ul {
    width: 100%;
    height:130px;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow: auto;
    white-space: nowrap;
    position: relative;
    padding: 0rem 0.8rem;
    box-sizing: border-box;
    .li {
      width: auto;
      height: 100%;
      // line-height: 3.5rem;
      margin-right: 0.5rem;
      display: inline-block;
      position: relative;
      .nav_img{
        height: 85px;
        width: 85px;
        margin-left: 12px;
      }
      .navBox-li-line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: #08568d;
      }
    }
    .li-activate {
      color: #08568d;
    }
    .li:last-child {
      margin-right: 7.5rem;
    }

  }
   // 隐藏滚动条
  .ul::-webkit-scrollbar {
    display: none;
  }
}
</style>
<style lang="css" scoped>
 html,body,#app{
    background-color: #eae8e8;
    /* height:1000px; */
  }
.classroom{
  height: auto;
  width:auto;
}
.van-nav-bar {
  background-color: #dd405e;
}
/* .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  top: 46%;
  color: #ffffff;
  font-weight: normal;
  font-size: 16px;
  font-family: Adobe Heiti Std;
} */
.fc-78482F {
  color: #78482f;
}
.page {
  overflow-x: hidden;
  background: #EAE8E8;
}

.header {
  width: 100%;
  height: 60px;
  margin: 0;
}

.header > img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.kqb-tools {
  margin: 0 30px 0 30px;
  padding: 20px 0 20px 0;
}

.kqb-tools .kqb-location {
  -webkit-align-items: center;
  align-items: center;
  width: 200px;
  height: 56px;
  margin: 0 24px 0 0;
  font-size: 28px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
}

.kqb-tools .kqb-location .icon-arrow-right-thin {
  width: 30px;
  height: 30px;
  margin: -2px 0 0 28px;
  font-size: 32px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -moz-transform: rotate(90deg);
  /* Firefox */
  -webkit-transform: rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  /* Opera */
}

.kqb-search-bar {
  /* width: 434px; */
  width: 100%;
  height: 56px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  /* border-radius: 10px; */
  border-radius: 30px;
  left: -4px;
}

.kqb-search-bar .icon_search {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 27px;
  height: 28px;
  transform: translate(0, -50%);
}

.kqb-search-bar input {
  height: 56px;
  line-height: 56px;
  padding: 0 36px 0 55px;
  font-size: 28px;
  border: 0;
}

.kqb-search-bar .placeholder {
  font-size: 28px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  color: rgba(199, 199, 199, 1);
}

.time {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
}

.time1 {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
  margin-left: 92%;
  margin-top: -6%;
}

.nav-bar {
  display: flex;
  background-color: #EAE8E8;
  margin: -28px 0px 19px 3px;
  /* padding: 26px 0 30px 0; */
  /* background: rgba(255, 255, 255, 1); */
  /* box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14); */
  border-radius: 10px;
  box-sizing: border-box;
}

.nav-bar .nav-bar-item {
  display: flex;
  /* flex-grow: 1; */
  flex-direction: column;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 60px;
}

.nav-bar .nav-bar-item img {
  max-width: 80px;
  height: 80px;
  margin: 0 auto;
  left:44px;
}

.nav-bar .nav-bar-item div {
  padding: 16px 0 0 0;
}

.bannerswipers {
  width: 100%;
  height: 377px;
  overflow: hidden;
}

.bannerswipers img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: block;
}

/*用来包裹所有的小圆点  */
.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */
.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

/*选中以后的小圆点样式  */
.banneractive {
  background-color: #d0021b;
}

.kqb-media-item {
  margin: 46px 0;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}

.kqb-media-object {
  max-width: 200px;
}
.kqb-media-object-img{
  border: 1px solid #000000;
  margin-top: 10px;
  height: 2.66667rem;
}

.section-title {
  margin: 61px 43px 47px 43px;
  padding: 0 0 0 28px;
  font-size: 33px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #000000;
}

.section-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 8px;
  height: 34px;
  background: rgba(249, 206, 23, 1);
  border-radius: 4px;
  transform: translate(0, -50%);
}

/* 分割线 */
.tableTitle {
  position: relative;
  margin: 0 auto;
  width: auto;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 16px;
  color: rgba(101, 101, 101, 1);
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
}

.section-title.disp-flex-between .more {
  align-self: flex-end;
  margin: 0 0 1px 0;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-style: normal;
  color: rgba(51, 51, 51, 0.5);
}

.section-title.disp-flex-between .more div.icon {
  width: 22px;
  height: 22px;
  margin: 0 0 0 9px;
  background: rgba(205, 203, 206, 1);
  border-radius: 50%;
  margin-top:7px;
}

.section-title.disp-flex-between .more div.icon:before,
.section-title.disp-flex-between .more div.icon:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}

.section-title.disp-flex-between .more div.icon:after {
  content: "\e602";
  font-family: "iconfont" !important;
  font-size: 15px;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}

/*音频组件*/
.kqb-audios {
  padding: 44px 60px 44px 49px;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
}

.kqb-audios .kqb-media-item {
  margin: 0;
  padding: 0;
  box-shadow: none;
}

.kqb-audios .kqb-media-item .kqb-media-title {
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-audios .kqb-media-item .kqb-media-object.circle {
  max-width: 87px;
  height: 87px;
}

.kqb-audios .kqb-media-item .kqb-media-footer {
  margin: 14px 0 0 0;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.kqb-audios .kqb-media-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 27px 0 0 0;
}

.kqb-audios .kqb-media-tools .icon-media-player,
.kqb-audios .kqb-media-tools .icon-media-stop {
  margin: 0 120px;
  font-size: 84px;
}

.kqb-audios .kqb-media-tools .icon-media-previous,
.kqb-audios .kqb-media-tools .icon-media-next {
  font-size: 60px;
}

/*进度条长度  */
.kqb-audios .slid {
  flex: 1;
  position: relative;
}

.kqb-audios slider {
  width: 100%;
  margin: 15px 0 0 16px;
}

/* 音频推荐 */
.audio-recommend.kqb-media-list {
  margin: 76px 43px 0 43px;
}

.audio-recommend.kqb-media-list .kqb-media-item {
  padding: 20px;
  box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14);
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group {
  -webkit-flex: 0 0 332px;
  flex: 0 0 332px;
  margin: -41px 0 0 0;
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group img {
  max-width: 332px;
  min-width: 332px;
  width: 332px;
  height: 190px;
  border-radius: 10px;
}
.kqb-media-inner{
  padding: 10px 0 0 0;
  /* height: 78%; */
  width: 91%;
  left: 12px;
}
.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-inner {
  width: 45%;
  margin: 0 0 0 16px;
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-desc {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.7);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 48, 26, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A
  .fc-30 {
  font-size: 30px;
}

button.kqb-btn.bgC-FFCC00-FFCC00 {
  width: 127px;
  height: 44px;
  line-height: 44px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  background: linear-gradient(
    -70deg,
    rgba(255, 204, 0, 1),
    rgba(255, 221, 0, 1)
  );
  border-radius: 0px 22px 22px 28px;
  border: 0;
  box-shadow: none;
}

.doyoulike.kqb-media-list,
.hotclass.kqb-media-list {
  margin: -22px 20px;
}

.doyoulike.kqb-media-list .kqb-media-item,
.hotclass.kqb-media-list .kqb-media-item {
  display: block;
  padding: 0;
  box-shadow: none;
  border: 1px solid white;
  height:396px;
}
.doyoulike.kqb-media-list {
  margin-bottom: 200px;
}
/* 热门课程 */
.hotclass.kqb-media-list {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  top:15px;
}

.hotclass.kqb-media-list .kqb-media-item {
  width: 49%;
  margin: 18px 0 0 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  margin: 0;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px 16px;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  border: 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-title {
  margin: 0.24rem 0 0.14667rem 0;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #000000;
  font-size: 29px;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc,
.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  width: 100%;
  line-height: 1.1;
  margin: 0 0 22px 0;
  text-align: left;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc {
  margin: 0 0 11px 0;
  color: rgba(102, 102, 102, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer.fc-FF1A1A,
.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/* 猜你喜欢
.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object-group .mask {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  padding: 0 17px;
  line-height: 46px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.5);
} */

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  height: 367px;
  border-radius: 10px;
}

.doyoulike.kqb-media-list .kqb-media-inner .kqb-media-item .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-footer {
  margin: 24px 0 0 0;
}

.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-000 {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
/* .fc-FF1A1A{
  bottom: 0px;
} */
.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/*modal*/
.modal {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.BGurl-modal {
  width: 90%;
  height: 755px;
  margin: 36% 0 0 0;
  padding: 80px 0 0 50px;
  box-sizing: border-box;
}

.BGurl-modal .artword {
  max-width: 418px;
  height: 121px;
  margin: 0 auto;
}

.BGurl-modal .fc-875940 {
  max-width: 418px;
  margin: 26px auto 0 auto;
  font-size: 24px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(135, 89, 64, 1);
}

.modal .nav-bar {
  width: 80%;
  margin: 33px auto 41px auto;
}

.modal .nav-bar .nav-bar-item {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
}

.modal .nav-bar .nav-bar-item img {
  max-width: 70px;
  height: 70px;
}

.modal .kqb-btn {
  position: absolute;
  bottom: 120px;
  left: 50%;
  width: 506px;
  height: 85px;
  margin: 0 auto;
  margin-left: 30px;
  border: 0;
  background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  );
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
  border-radius: 43px;
  transform: translate(-50%, 0);
}

.modal .kqb-btn text {
  font-size: 36px;
  font-family: MicrosoftYaHei-Bold;
  color: rgba(120, 72, 47, 1);
}

.modal .kqb-btn text:first-child {
  font-weight: bold;
}

.modal .icon-canel2 {
  position: absolute;
  bottom: -80px;
  left: 50%;
  color: #fff;
  margin-left: 30px;
  transform: translate(-50%, 0);
}

button.kqb-btn.fc-78482F {
  background-color: #78482f;
}

button.kqb-btn.fc-78482F span:first-child {
  font-size: 40px;
  font-weight: bold;
}

.share-button {
  position: fixed;
  bottom: 140px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
</style>
<style>
/* 修改框架样式 */
.van-tabbar-item__icon img {
  width: auto;
  height: 29px !important;
}
</style>

<style lang="css" >
 html,body,#app{
    background-color: #eae8e8;
  }
.wrapper >>> .swiper-pagination-bullet-active {
  background: #fff;
}
.my-bullet-active {
  background: #ffffff;
  background: rgba(255, 255, 255, 0.5) !important;
  /*opacity: 0.6;*/
}
.my-swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  top: -15px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  margin-left: 15px;
  opacity: 0.3;
}
.wrapper {
  width: 100%;
  /* height: 310px; */
  height: auto;
  overflow: hidden;
  /* padding-bottom: 31.25%; */
  margin: 33px 0 30px -0;
}

.swiper-img {
  width: 100%;
  height: 385px;
  border-radius:10px;
}
</style>
